import { Slide } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React from 'react';

interface IChildren {
  children: React.ReactElement;
}

const Transition = React.forwardRef((props: TransitionProps & IChildren, ref: React.Ref<unknown>) => {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default Transition;
